export const shouldUpliftBannerDisplay = (upliftSettings, pageName) => {
  if (!upliftSettings) {
    return false;
  }
  //check if uplift available globally
  const isGlobalActive = upliftSettings.pages?.find(
    item => item.pageName === 'global' && item.pageValue === true
  );
  if (!isGlobalActive) {
    return false;
  }
  //check if uplift available on page
  const isPageActive = upliftSettings.pages?.find(
    item => item.pageName === pageName && item.pageValue === true
  );
  if (!isPageActive) {
    return false;
  }

  return true;
};

export const canShowBanner = (isUpliftBannerVisible, isNotAgent) => {
  return isUpliftBannerVisible && isNotAgent;
};
